import { render, staticRenderFns } from "./CaseStudyComponent.vue?vue&type=template&id=cb0d1424&"
import script from "./CaseStudyComponent.vue?vue&type=script&lang=js&"
export * from "./CaseStudyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports